// extracted by mini-css-extract-plugin
export default {"stickyTab":"Home_stickyTab__x9IRh"};